/* Quick-add avec quantités sur les grilles produit (composant <nm-quick-qty>).
   UI optimiste : les clics ajustent l'affichage immédiatement, puis une seule
   requête (debounce) envoie la QUANTITÉ ABSOLUE — pas de course possible.
   Badge panier + drawer rafraîchis via la Section Rendering API, sans ouvrir
   le drawer (on reste dans la grille). */
(function () {
  'use strict';

  var serverQty = {}; // variant_id -> quantité connue côté serveur
  var localQty = {}; // variant_id -> quantité affichée (optimiste)
  var timers = {}; // variant_id -> debounce
  var inflight = {}; // variant_id -> promesse en cours

  function fetchCart() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function syncFromCart(c) {
    serverQty = {};
    (c.items || []).forEach(function (i) { serverQty[i.variant_id] = i.quantity; });
    Object.keys(localQty).forEach(function (v) {
      if (!timers[v] && !inflight[v]) delete localQty[v];
    });
    paint();
    updateTray(c);
  }

  /* Pastille panier flottante (nm-cart-tray) : compteur + total, masquée à vide */
  function updateTray(c) {
    var tray = document.getElementById('nm-cart-tray');
    if (!tray) return;
    var count = c.item_count || 0;
    if (tray.hidden !== (count === 0)) tray.hidden = count === 0;
    var countEl = tray.querySelector('.nm-tray__count');
    var totalEl = tray.querySelector('.nm-tray__total');
    var cs = String(count);
    if (countEl && countEl.textContent !== cs) countEl.textContent = cs;
    var t = (c.total_price / 100).toFixed(2).replace('.', ',') + ' €';
    if (totalEl && totalEl.textContent.trim() !== t) totalEl.textContent = t;
  }

  function shownQty(variant) {
    return variant in localQty ? localQty[variant] : serverQty[variant] || 0;
  }

  function paint() {
    // N'écrire dans le DOM QUE si la valeur change : paint() tourne aussi sur
    // les mutations de la grille — une écriture inconditionnelle re-déclenche
    // l'observer et gèle la page (boucle infinie).
    document.querySelectorAll('nm-quick-qty').forEach(function (el) {
      var add = el.querySelector('.nm-qq__add');
      var step = el.querySelector('.nm-qq__step');
      var n = el.querySelector('.nm-qq__n');
      if (!add || !step || !n) return;
      var q = shownQty(+el.dataset.variant);
      var qs = String(q);
      if (add.hidden !== (q > 0)) add.hidden = q > 0;
      if (step.hidden !== (q === 0)) step.hidden = q === 0;
      if (n.textContent !== qs) n.textContent = qs;
    });
  }

  function patchSections(sections) {
    if (!sections) return;
    try {
      var parser = new DOMParser();
      if (sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        var doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        var inner = doc.querySelector('.shopify-section') || doc.body;
        if (bubble && inner) bubble.innerHTML = inner.innerHTML;
      }
      if (sections['cart-drawer']) {
        // Remplacement CHIRURGICAL : uniquement .drawer__inner (remplacer tout
        // #CartDrawer détruirait l'overlay et son listener de fermeture).
        // ⚠️ Deux nœuds distincts : <cart-drawer> (élément custom, porte les
        // classes d'état is-empty/active) ≠ #CartDrawer (div interne).
        var drawerRoot = document.querySelector('cart-drawer');
        var parsedDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        var nextRoot = parsedDoc.querySelector('cart-drawer');
        var nextInner = parsedDoc.querySelector('.drawer__inner');
        var curInner = drawerRoot ? drawerRoot.querySelector('.drawer__inner') : null;
        if (curInner && nextInner) {
          curInner.innerHTML = nextInner.innerHTML;
          curInner.className = nextInner.className;
        }
        // Refléter UNIQUEMENT l'état vide sur le bon élément — jamais toucher
        // à 'active' (le drawer peut être ouvert pendant le patch).
        if (drawerRoot && nextRoot) {
          drawerRoot.classList.toggle('is-empty', nextRoot.classList.contains('is-empty'));
        }
      }
    } catch (e) { /* cosmétique uniquement — ne jamais casser le flux panier */ }
  }

  function flush(variant) {
    delete timers[variant];
    if (inflight[variant]) return; // repassera au retour
    var target = localQty[variant];
    if (target === undefined || target === (serverQty[variant] || 0)) { delete localQty[variant]; paint(); return; }

    var body = { sections: 'cart-icon-bubble,cart-drawer' };
    var url;
    if (!(variant in serverQty) || serverQty[variant] === 0) {
      url = '/cart/add.js';
      body.id = variant;
      body.quantity = target;
    } else {
      url = '/cart/update.js';
      body.updates = {};
      body.updates[variant] = target;
    }
    inflight[variant] = fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { patchSections(data.sections); })
      .catch(function () {})
      .then(function () {
        delete inflight[variant];
        return fetchCart().then(function (c) {
          // vérité serveur (gère aussi les plafonds de stock)
          var stillPending = variant in timers;
          if (!stillPending) delete localQty[variant];
          syncFromCart(c);
          if (stillPending) paint();
          else if (timers[variant] === undefined && localQty[variant] !== undefined) flush(variant);
        });
      });
  }

  function bump(variant, delta) {
    localQty[variant] = Math.max(0, shownQty(variant) + delta);
    paint();
    clearTimeout(timers[variant]);
    timers[variant] = setTimeout(function () { flush(variant); }, 450);
  }

  // Synchronisation globale exposée aux apps embarquées (boutique singles) :
  // rafraîchit bulle header + drawer + pastille + steppers après leurs
  // propres mutations du panier.
  window.NMCartSync = function () {
    fetch(window.location.pathname + '?sections=cart-icon-bubble,cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(patchSections)
      .catch(function () {});
    fetchCart().then(syncFromCart);
  };

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#nm-cart-tray')) {
      // Page singles : ouvrir le panier unifié de l'app plutôt que le drawer Dawn
      if (typeof window.NMOpenSinglesCart === 'function') { window.NMOpenSinglesCart(); return; }
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') d.open();
      else window.location.href = '/cart';
      return;
    }
    var root = e.target.closest && e.target.closest('nm-quick-qty');
    if (!root) return;
    var variant = +root.dataset.variant;
    if (e.target.closest('.nm-qq__add') || e.target.closest('.nm-qq__plus')) bump(variant, 1);
    else if (e.target.closest('.nm-qq__minus')) bump(variant, -1);
  });

  function init() {
    fetchCart().then(syncFromCart);
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      var moTimer;
      new MutationObserver(function () {
        clearTimeout(moTimer);
        moTimer = setTimeout(paint, 120);
      }).observe(container, { childList: true, subtree: true });
    }
    // Changements de panier initiés par Dawn (drawer, fiche produit…) :
    // resynchroniser les steppers de la grille via le pub/sub du thème.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        fetchCart().then(syncFromCart);
      });
    }
    // La pastille se soulève au-dessus de la barre CTA sticky (fiche produit)
    var sb = document.querySelector('.nm-stickybar');
    var tray = document.getElementById('nm-cart-tray');
    if (sb && tray) {
      new MutationObserver(function () {
        tray.classList.toggle('nm-tray--raised', sb.classList.contains('nm-show'));
      }).observe(sb, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
